import { render } from "./AccountSwitch.vue?vue&type=template&id=70104a16"
import script from "./AccountSwitch.vue?vue&type=script&lang=js"
export * from "./AccountSwitch.vue?vue&type=script&lang=js"

import "./AccountSwitch.vue?vue&type=style&index=0&id=70104a16&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__